'use strict';

angular.module('basketModule')
.factory('downloadAction', downloadAction);

function downloadAction(BasketService)
{
    return {
        name: 'download',
        label: 'Zip files',
        icon: 'material-icon-file-download',
        buttonClass: 'btn btn-primary',
        template: '<i class="material-icon {{ action.icon }}"></i> {{ action.label }}',
        show: () => BasketService.length(),
        act: function ()
        {
            this.label = 'Zipping files...';
            this.icon = 'material-icon-cached spinning';
            this.buttonClass = 'btn btn-primary';

            BasketService.download().then((data) =>
            {
                this.label = 'Zip files';
                this.icon = 'material-icon-file-download';
                this.buttonClass = 'btn btn-primary';

                if (!data) {
                    return;
                }

                let a = document.createElement('A');
                a.target='__blank';
                a.href = 'api/baskets/download?path=' + data.url;

                a.download = data.url.substr(data.url.lastIndexOf('/') + 1);
                document.body.appendChild(a);
                this.clearAfterDownload = true;

                a.click();

                document.body.removeChild(a);
                BasketService.removeAll();
            });
        }
    };
}
